import { useApiGet } from '../../api/api.hooks';
import { APP_CONFIG } from '../../config';

export function useBankInfo(countryId: string) {
  return useApiGet<string>(APP_CONFIG.api.bankInfo(countryId));
}
